import React from "react";
import styled from "styled-components";
import ApiAuthor from "models/data/api/ApiAuthor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";

const Title = styled.h1`
  font-family: ${(props) => props.theme.fonts.poppins};
`;

const AuthorImage = styled.div<any>`
  background-image: url("${(props: any) => props.src}");
  background-size: cover;
  background-position: center;
`;

const AuthorDescription = styled.p`
  font-family: ${(props) => props.theme.fonts.karma};
`;

const AuthorInformationContainer = styled.div`
  max-width: 1000px;
`;

const IconContainer = styled.div`
  &:hover {
    opacity: 0.5;
    color: ${(props) => props.theme.colors.orange};
  }
`;

export default function AuthorInformation({ author }) {
  return (
    <div className="w-full flex flex-col items-center pt-6">
      <AuthorInformationContainer className="flex md:flex-row flex-col items-start justify-center p-4">
        <AuthorImage
          className="h-48 w-48 rounded-full flex flex-shrink-0"
          src={ApiAuthor.pictureUrl(author)}
        />
        <div className="flex flex-col md:pl-10 md:py-0 py-4">
          <Title className="text-2xl font-bold">
            {ApiAuthor.fullName(author)}
          </Title>
          <div className="flex flex-row">
            {ApiAuthor.hasTwitter(author) && (
              <button
                className="flex py-4"
                onClick={() =>
                  window.open(
                    `https://www.twitter.com/${ApiAuthor.twitter(author)}`,
                    "_blank"
                  )
                }
              >
                <IconContainer>
                  <FontAwesomeIcon icon={faTwitter} size="2x" />
                  {/* <TwitterIcon size={32} round iconBgStyle={{ fill: "black" }} /> */}
                </IconContainer>
              </button>
            )}
            {ApiAuthor.hasInstagram(author) && (
              <button
                className="flex py-4 p-2"
                onClick={() =>
                  window.open(
                    `https://www.instagram.com/${ApiAuthor.instagram(author)}`,
                    "_blank"
                  )
                }
              >
                <IconContainer>
                  <FontAwesomeIcon icon={faInstagram} size="2x" />
                  {/* <TwitterIcon size={32} round iconBgStyle={{ fill: "black" }} /> */}
                </IconContainer>
              </button>
            )}
          </div>
          <AuthorDescription className="text-xl">
            {ApiAuthor.shortBiography(author)}
          </AuthorDescription>
        </div>
      </AuthorInformationContainer>
      <div className="w-full h-px bg-gray-400 md:mt-10 mt-4" />
    </div>
  );
}
